import { render, staticRenderFns } from "./softWare.vue?vue&type=template&id=e51bd35e&scoped=true"
import script from "./softWare.vue?vue&type=script&lang=js"
export * from "./softWare.vue?vue&type=script&lang=js"
import style0 from "./softWare.vue?vue&type=style&index=0&id=e51bd35e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51bd35e",
  null
  
)

export default component.exports